export const CREATE_ARCHITECTURECOMPANYLEADS = "CREATE_ARCHITECTURECOMPANYLEADS";   
export const RETRIEVE_ARCHITECTURECOMPANYLEADS = "RETRIEVE_ARCHITECTURECOMPANYLEADS";
export const RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS = "RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS";
export const RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS = "RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS";
export const RETRIEVESINGLE_ARCHITECTURECOMPANYLEADS = "RETRIEVESINGLE_ARCHITECTURECOMPANYLEADS";
export const UPDATE_ARCHITECTURECOMPANYLEADS = "UPDATE_ARCHITECTURECOMPANYLEADS";   
export const DELETE_ARCHITECTURECOMPANYLEADS = "DELETE_ARCHITECTURECOMPANYLEADS";   
